/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { handleNetworkError } from '@/account/lib/network-error';
import { fetchGraphQl } from '@/account/api/fetch-graphql';
import { GET_CUSTOMER_ADDRESS } from './graphql/getCustomerAddress.graphql';
import { transformMultipleAddresses } from '@/account/data/transforms';
import { CustomerAddressesModel } from '@/account/data/models/customer-address';
import { AddressResponse } from '@/account/types';
import { handleFetchError } from '@/account/lib/fetch-error';

export const getCustomerAddress = async (): Promise<
  CustomerAddressesModel[]
> => {
  return await fetchGraphQl(GET_CUSTOMER_ADDRESS, {
    method: 'GET',
    cache: 'no-cache',
  })
    .then((response: AddressResponse) => {
      if (response.errors?.length) return handleFetchError(response.errors);

      return transformMultipleAddresses(response);
    })
    .catch(handleNetworkError);
};
